export const urlAPI = 'https://admin.app.elle-et-la.com';
//export const urlAPI = 'https://api-elleetla.juliengrelet.com';
//https://admin.app.elle-et-la.com
//http://api.elleetla.local
//https://appelleetla.infime.ovh
